<template>
  <div class="cart-stepper">
    <div class="cart-step" :class="{active:current_step === 'panier'}">
      <div class="cart-step-number">
        <span>1</span>
      </div>
      <div class="cart-step-libelle">
        <span>{{$_('my_cart')}}</span>
      </div>
    </div>
    <div class="cart-step" :class="{active:current_step === 'livraison'}">
      <div class="cart-step-number">
        <span>2</span>
      </div>
      <div class="cart-step-libelle">
        <span>{{$_('delivery')}}</span>
      </div>
    </div>
    <div class="cart-step" :class="{active:current_step === 'paiement'}">
      <div class="cart-step-number">
        <span>3</span>
      </div>
      <div class="cart-step-libelle">
        <span>{{$_('payment')}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'CartStepper',
  data() {
    return {
      current_step: 'panier',
    }
  },
  created() {
    this.current_step = this.$route.path.split('/')[1];
  }
}
</script>

<style scoped>
.cart-stepper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px 0px 20px; 
  border-bottom: solid 1px #E9E9E9;
}
.cart-step {
  display: flex;
  align-items: center;
}
.cart-step:not(:last-child):after {
  content: '';
  width: 50px;
  height: 1px;
  background: #E9E9E9;
  margin: 0px 10px;
  margin-top: 2px;
}
.cart-step-libelle {
  color: #61424D;
  font-size: var(--fz-md);
}
.cart-step-number {
  width: 25px;
  height: 25px;
  border: solid 1px #61424D;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 10px;
}
.cart-step-number span {
  font-size: var(--fz-sm);
  font-family: 'Lato-Medium';
  color: #61424D;
}
.cart-step.active .cart-step-libelle {
  color: #F00B35;
}
.cart-step.active .cart-step-number {
  border: solid 1px #F00B35;
  background-color: #F00B35;
}
.cart-step.active .cart-step-number span {
  color: #fff;
}

@media screen and (max-width: 800px){
  .cart-stepper {
    flex-direction: column;
    width: 100%;
  }
  .cart-step:not(:last-child):after {
    content: '';
    display: none;
  }
  .cart-stepper .cart-step {
    margin: 10px;
    text-align: center;
  }
}

</style>